import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AmaService } from '../ama.service';
@Component({
  selector: "app-view-details",
  templateUrl: "./view-details.component.html",
  styleUrls: ["./view-details.component.css"],
})
export class ViewDetailsComponent implements OnInit {
  Index: number;
 
  filledQue: any={};

  constructor(private Route: ActivatedRoute, public amaService: AmaService, private router: Router) { }
  ngOnInit() {
    console.log("question_id", this.Route.snapshot.params.Id)
    this.amaService.getQuestionDetails(this.Route.snapshot.params.Id).subscribe((result) => {
      this.filledQue=result;
      console.log('after getQuestionDetails UI Result:: ', result);
    }, (err) => {
      console.log('after getQuestionDetails UI Error:: ', err);
    });
    this.Index = this.Route.snapshot.params.Id;
  }

  breadcrumbClick() {
    this.router.navigate(["ama/request-list"]);
  }
  ConvertDate = (date: any) => {
    var d = date.slice(0, 10);
    var arr = d.split('-');
    var year = +arr[0];
    var month = +arr[1];
    var day = +arr[2];
    var arr1 = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    var res = day + " " + arr1[month-1] + ' ' + year;
    return res;
  }
  ConvertItem = (val:any) =>
  {
    return val === 'SEC A'?'NCCS A':'NCCS B';
  }
  onViewReport(){
    console.log("clicked")
    // this.router.navigate([`home/repository-report/details/${this.filledQue.data[0].uuid}`]);
    this.router.navigate([`repo/details/${this.filledQue.data[0].uuid}`]);
  }
}
